import React, { useRef, useState, useEffect } from "react";

export default function PlayOverlayVideo({ src, poster, className, showNativeControls = true }) {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const v = videoRef.current;
    if (!v) return;

    const onPlay = () => setIsPlaying(true);
    const onPause = () => setIsPlaying(false);
    const onEnded = () => setIsPlaying(false);
    const onLoaded = () => setIsLoaded(true);

    v.addEventListener("play", onPlay);
    v.addEventListener("pause", onPause);
    v.addEventListener("ended", onEnded);
    v.addEventListener("loadedmetadata", onLoaded);

    return () => {
      v.removeEventListener("play", onPlay);
      v.removeEventListener("pause", onPause);
      v.removeEventListener("ended", onEnded);
      v.removeEventListener("loadedmetadata", onLoaded);
    };
  }, []);

  const togglePlay = async () => {
    const v = videoRef.current;
    if (!v) return;
    try {
      if (v.paused) {
        await v.play();
      } else {
        v.pause();
      }
    } catch (err) {
      console.warn("Video play failed:", err);
    }
  };

  return (
    <div
      className={className}
      style={{
        position: "relative",
        width: "100%",
        display: "block",
        maxWidth: "100%",
      }}
    >
      <video
        ref={videoRef}
        src={src}
        poster={poster}
        controls={showNativeControls}
        style={{ width: "100%", height: "auto", display: "block" }}
      />

      {!isPlaying && isLoaded && (
        <button
          onClick={togglePlay}
          aria-label="Play video"
          style={{
            position: "absolute",
            inset: 0,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            background: "rgba(0,0,0,0.35)",
            border: "none",
            cursor: "pointer",
          }}
        >
          <div
            style={{
              width: 96,
              height: 96,
              borderRadius: "50%",
              background: "rgba(255,255,255,0.9)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              boxShadow: "0 6px 18px rgba(0,0,0,0.4)",
            }}
          >
            <svg viewBox="0 0 24 24" width="48" height="48" aria-hidden="true">
              <path d="M8 5v14l11-7z" fill="black" />
            </svg>
          </div>
        </button>
      )}
    </div>
  );
}
